import { Link } from "react-router-dom";
import { useLocalePath } from "../hooks/useLocalePath";

/**
 * Card displayed on the careers page.
 *
 * @param {{
 *   job: { id: string, title: string, teaser?: string, category?: string, workType?: string, image?: string, location?: string },
 * }} props
 */
const JobCard = ({ job }) => {
  const { localePath } = useLocalePath();

  return (
    <Link
      to={localePath(`/jobs/${job.slug}`)}
      className="group block overflow-hidden shadow-sm hover:shadow-lg transition-all bg-surface text-text-body border border-border-default hover:bg-primary hover:text-white hover:border-primary"
      data-testid={`job-card-${job.slug}`}
    >
      <div className="flex flex-col md:flex-row">
        {/* Content side */}
        <div className="flex-1 p-6 sm:p-8 flex flex-col justify-center order-2 md:order-1">
          <div className="flex flex-wrap gap-2 mb-4">
            {job.category && (
              <span className="text-sm px-4 py-1 rounded bg-primary text-white group-hover:bg-white group-hover:text-primary transition-colors">
                {job.category}
              </span>
            )}
            {job.workType && (
              <span className="text-sm px-4 py-1 rounded bg-primary text-white group-hover:bg-white group-hover:text-primary transition-colors">
                {job.workType}
              </span>
            )}
          </div>
          <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-text-strong group-hover:text-white transition-colors">
            {job.title}
          </h3>
          {job.teaser && (
            <p className="text-base sm:text-lg text-text-muted group-hover:text-white/85 transition-colors">
              {job.teaser}
            </p>
          )}
        </div>

        {/* Image side */}
        {job.imageUrl && (
          <div className="md:w-1/3 md:flex-shrink-0 order-1 md:order-2">
            <img
              src={job.imageUrl}
              alt={job.title}
              className="w-full h-48 md:h-full object-cover"
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export default JobCard;
